import { render } from "./SignUp.vue?vue&type=template&id=fa5540a8&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=fa5540a8&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa5540a8"]])

export default __exports__